// Generated by purs version 0.15.0
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var encodeEnum = function (dict) {
    return dict.encodeEnum;
};
var genericEncodeEnum = function (dictGeneric) {
    return function (dictGenericEncodeEnum) {
        return function (opts) {
            var $34 = encodeEnum(dictGenericEncodeEnum)(opts);
            var $35 = Data_Generic_Rep.from(dictGeneric);
            return function ($36) {
                return $34($35($36));
            };
        };
    };
};
var sumGenericEncodeEnum = function (dictGenericEncodeEnum) {
    return function (dictGenericEncodeEnum1) {
        return {
            encodeEnum: function (opts) {
                return function (v) {
                    if (v instanceof Data_Generic_Rep.Inl) {
                        return encodeEnum(dictGenericEncodeEnum)(opts)(v.value0);
                    };
                    if (v instanceof Data_Generic_Rep.Inr) {
                        return encodeEnum(dictGenericEncodeEnum1)(opts)(v.value0);
                    };
                    throw new Error("Failed pattern match at Foreign.Generic.EnumEncoding (line 93, column 1 - line 97, column 46): " + [ opts.constructor.name, v.constructor.name ]);
                };
            }
        };
    };
};
var defaultGenericEnumOptions = {
    constructorTagTransform: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var decodeEnum = function (dict) {
    return dict.decodeEnum;
};
var genericDecodeEnum = function (dictGeneric) {
    return function (dictGenericDecodeEnum) {
        return function (opts) {
            var $37 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.to(dictGeneric));
            var $38 = decodeEnum(dictGenericDecodeEnum)(opts);
            return function ($39) {
                return $37($38($39));
            };
        };
    };
};
var sumGenericDecodeEnum = function (dictGenericDecodeEnum) {
    return function (dictGenericDecodeEnum1) {
        return {
            decodeEnum: function (opts) {
                return function (f) {
                    return Control_Alt.alt(Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.Inl.create)(decodeEnum(dictGenericDecodeEnum)(opts)(f)))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Generic_Rep.Inr.create)(decodeEnum(dictGenericDecodeEnum1)(opts)(f)));
                };
            }
        };
    };
};
var ctorProductGenericEncodeEnum = function () {
    return {
        encodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable encodeEnum was reached.");
            };
        }
    };
};
var ctorProductGenericDecodeEnum = function () {
    return {
        decodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable decodeEnum was reached.");
            };
        }
    };
};
var ctorNoArgsGenericEncodeEnum = function (dictIsSymbol) {
    return {
        encodeEnum: function (v) {
            return function (v1) {
                var ctorName = v.constructorTagTransform(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value));
                return Foreign.unsafeToForeign(ctorName);
            };
        }
    };
};
var ctorNoArgsGenericDecodeEnum = function (dictIsSymbol) {
    return {
        decodeEnum: function (v) {
            return function (f) {
                var ctorName = v.constructorTagTransform(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value));
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign.readString(Data_Identity.monadIdentity)(f))(function (tag) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Applicative.unless(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(tag === ctorName)(Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError("Expected " + (Data_Show.show(Data_Show.showString)(ctorName) + (" tag for unary constructor literal " + ctorName))))))(function () {
                        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Generic_Rep.NoArguments.value);
                    });
                });
            };
        }
    };
};
var ctorArgumentGenericEncodeEnum = function () {
    return {
        encodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable encodeEnum was reached.");
            };
        }
    };
};
var ctorArgumentGenericDecodeEnum = function () {
    return {
        decodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable decodeEnum was reached.");
            };
        }
    };
};
export {
    decodeEnum,
    encodeEnum,
    defaultGenericEnumOptions,
    genericDecodeEnum,
    genericEncodeEnum,
    sumGenericDecodeEnum,
    ctorNoArgsGenericDecodeEnum,
    ctorArgumentGenericDecodeEnum,
    ctorProductGenericDecodeEnum,
    sumGenericEncodeEnum,
    ctorNoArgsGenericEncodeEnum,
    ctorArgumentGenericEncodeEnum,
    ctorProductGenericEncodeEnum
};
//# sourceMappingURL=index.js.map
